import {Outlet, useOutletContext} from "react-router";

export const ReportsContainer = () => {
    const {filters} = useOutletContext();

    return (
        <div style={{marginTop: 30, marginBottom: 100}}>
            <Outlet context={{filters}}/>
        </div>
    );
};